document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("filter-toggle") ||
    e.target.closest(".filter-toggle")
  ) {
    let el = e.target.classList.contains("filter-toggle")
      ? e.target
      : e.target.closest(".filter-toggle");
    let filterWrap = document.querySelector(".filter-wrapper");
    let filterOverlay = document.querySelector(".filter-overlay");
    filterWrap.classList.toggle("active");
    filterOverlay.classList.toggle("active");
  }
});
